import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EntitiesCardBody } from '../entities-card/EntitiesCardBody';
import { SearchMainSnippetCard } from '../../search/components/search-snippets/main/SearchMainSnippetCard';
import { LegislationCardTitleLink } from '../../legislation/card/LegislationCardTitleLink';
import styles from './legislative_text_snippet.module.scss';

type Props = {
  title: string;
  href: string;
  articleCount: number;
  source: string;
};

export const LegislativeTextSnippet: FC<Props> = ({
  title,
  href,
  articleCount,
  source,
}) => (
  <SearchMainSnippetCard>
    <EntitiesCardBody>
      <LegislationCardTitleLink source={source} href={href}>
        {title}
      </LegislationCardTitleLink>
      {articleCount > 0 && (
        <div className={styles.count}>
          <FormattedMessage
            id="legislative-text-snippet/LegislativeTextSnippet.tsx/1"
            values={{
              emphasis: (message: string) => <strong>{message}</strong>,
              count: articleCount,
            }}
          />
        </div>
      )}
    </EntitiesCardBody>
  </SearchMainSnippetCard>
);
